<script setup lang="ts">
import { Bell, ChevronDown } from 'lucide-vue-next'
import { storeToRefs } from 'pinia'
import { onBeforeUnmount, onMounted } from 'vue'
import AppSidebar from '@/components/AppSidebar.vue'
import ContextPanel from '@/components/ContextPanel.vue'
import CreditPill from '@/components/CreditPill.vue'
import SlotPill from '@/components/SlotPill.vue'
import { useAuthStore } from '@/stores/auth'
import { useAdvisorStore, useAgentStore, useBrowserStore, useConnectionStore, useExecutionStore, useGoalStore, useKnowledgeStore, usePortfolioStore, useProjectStore, useUsageStore, useWorkflowStore } from '@/stores/domain'

const authStore = useAuthStore()
const { displayName } = storeToRefs(authStore)
const projectStore = useProjectStore()
const goalStore = useGoalStore()
const portfolioStore = usePortfolioStore()
const executionStore = useExecutionStore()
const agentStore = useAgentStore()
const workflowStore = useWorkflowStore()
const connectionStore = useConnectionStore()
const knowledgeStore = useKnowledgeStore()
const browserStore = useBrowserStore()
const advisorStore = useAdvisorStore()
const usageStore = useUsageStore()

onMounted(() => {
  const uid = authStore.user?.uid
  if (!uid) return
  projectStore.subscribe(uid)
  goalStore.subscribe(uid)
  portfolioStore.subscribe(uid)
  executionStore.subscribe(uid)
  agentStore.subscribe(uid)
  workflowStore.subscribe(uid)
  connectionStore.subscribe(uid)
  knowledgeStore.subscribe(uid)
  browserStore.subscribe(uid)
  advisorStore.subscribe(uid)
  usageStore.subscribe(uid)
})

onBeforeUnmount(() => {
  projectStore.dispose()
  goalStore.dispose()
  portfolioStore.dispose()
  executionStore.dispose()
  agentStore.dispose()
  workflowStore.dispose()
  connectionStore.dispose()
  knowledgeStore.dispose()
  browserStore.dispose()
  advisorStore.dispose()
  usageStore.dispose()
})
</script>

<template>
  <div class="app-shell">
    <AppSidebar />
    <main class="app-main">
      <header class="app-topbar">
        <div class="app-topbar__mobile-title">skip<span>hr</span></div>
        <div class="app-topbar__actions">
          <CreditPill />
          <SlotPill />
          <button type="button" class="icon-button" aria-label="Notifications">
            <Bell :size="18" />
            <span class="notification-dot"></span>
          </button>
          <button type="button" class="profile-button">
            <span class="avatar">{{ displayName.slice(0, 1).toUpperCase() }}</span>
            <span class="profile-button__name">{{ displayName }}</span>
            <ChevronDown :size="14" />
          </button>
        </div>
      </header>
      <RouterView />
    </main>
    <ContextPanel />
  </div>
</template>
